<klt-section title="Balance sheet strength">
  <div class="graph-box">
    <klt-graph
      [loading]="loading"
      [height]="height"
      [options]="options"
      [titles]="titles"
      (filter)="runFilter($event)"
    >
    </klt-graph>
  </div>
</klt-section>
